export default __webpack_public_path__ + "static/media/digitizeLineString.7800225a.cur";